/**
 * HLF Beast Header — External JavaScript
 * Version: 3.0.0
 *
 * Reads configuration from data attributes on .hlf-header:
 *   data-search-url     — Shopify search route
 *   data-account-url    — Account / login route
 *   data-cart-url        — Cart route
 *   data-search-phrases — JSON array of typewriter placeholder strings
 *
 * Drawer logic → hlf-mobile-drawer.js
 */
(function () {
  const header = document.querySelector('.hlf-header');
  if (!header) return;

  /* ---- 1. Typewriter Animation ---- */
  const phrasesRaw = header.dataset.searchPhrases;
  const phrases = phrasesRaw ? JSON.parse(phrasesRaw).filter(p => p.trim() !== '') : [];

  if (phrases.length > 0) {
    const typewriterEls = Array.from(header.querySelectorAll('[data-hlf-typewriter], [data-hlf-typewriter-mobile]'));

    const popupInput = document.querySelector('[data-hlf-typewriter-input]');
    if (popupInput) typewriterEls.push(popupInput);

    function setupTypewriter(elements) {
      if (!elements.length) return;
      let phraseIndex = 0;
      let charIndex = 0;
      let isDeleting = false;

      function type() {
        const currentPhrase = phrases[phraseIndex];
        const displayText = isDeleting
          ? currentPhrase.substring(0, charIndex--)
          : currentPhrase.substring(0, charIndex++);

        elements.forEach(el => {
          if (el.tagName.toLowerCase() === 'input') {
            el.setAttribute('placeholder', displayText + (isDeleting ? '' : '|'));
          } else {
            el.textContent = displayText;
          }
        });

        let typingSpeed = isDeleting ? 50 : 150;
        if (!isDeleting && charIndex > currentPhrase.length) {
          isDeleting = true;
          typingSpeed = 2000;
        } else if (isDeleting && charIndex < 0) {
          isDeleting = false;
          phraseIndex = (phraseIndex + 1) % phrases.length;
          charIndex = 0;
          typingSpeed = 500;
        }
        setTimeout(type, typingSpeed);
      }
      type();
    }
    setupTypewriter(typewriterEls);
  }

  /* ---- 2. Event Delegation ---- */
  const searchUrl = header.dataset.searchUrl || '/search';
  const accountUrl = header.dataset.accountUrl || '/account';
  const cartUrl = header.dataset.cartUrl || '/cart';

  header.addEventListener('click', (e) => {
    const target = e.target.closest(
      '[data-hlf-search-trigger], [data-hlf-cart-trigger], [data-hlf-account-trigger], [data-hlf-menu-trigger], [data-hlf-drawer-close]'
    );
    if (!target) return;

    e.preventDefault();

    // Search Trigger
    if (target.hasAttribute('data-hlf-search-trigger')) {
      const popup = document.querySelector('hlf-search-popup');
      if (popup) popup.open();
      else window.location.href = searchUrl;
    }

    // Account Trigger (Kwikpass)
    else if (target.hasAttribute('data-hlf-account-trigger')) {
      const details = header.querySelector('header-drawer details[open]');
      if (details) {
        const summary = details.querySelector('summary');
        if (summary) summary.click();
      }

      if (typeof handleKpAndShopifyLogin === 'function') {
        handleKpAndShopifyLogin(accountUrl);
      } else {
        window.location.href = accountUrl;
      }
    }

    // Cart Trigger
    else if (target.hasAttribute('data-hlf-cart-trigger')) {
      const details = header.querySelector('header-drawer details[open]');
      if (details) {
        const summary = details.querySelector('summary');
        if (summary) summary.click();
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.open) {
        cartDrawer.open();
      } else {
        const cartBtn = document.querySelector('#cart-icon-bubble, .header__icon--cart');
        if (cartBtn) cartBtn.click();
        else window.location.href = cartUrl;
      }
    }

    // Menu Trigger
    else if (target.hasAttribute('data-hlf-menu-trigger')) {
      const drawerSummary = header.querySelector('header-drawer details summary');
      if (drawerSummary) drawerSummary.click();
    }

    // Drawer Close
    else if (target.hasAttribute('data-hlf-drawer-close')) {
      const summary = header.querySelector('header-drawer details summary');
      if (summary) summary.click();
    }
  });

  /* ---- 3. Cart Count Update ---- */
  document.addEventListener('cart:update', (e) => {
    const count = e.detail?.resource?.item_count ?? e.detail?.data?.itemCount;
    if (count !== undefined) {
      document.querySelectorAll('[data-hlf-cart-count]').forEach(el => (el.textContent = count));
    }
  });

  // Listen to Dawn's global cart update event (used by product page & sticky ATC)
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        const cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        fetch(`${cartUrl}.js`)
          .then(res => res.json())
          .then(cartData => {
            document.dispatchEvent(new CustomEvent('cart:update', {
              detail: { data: { itemCount: cartData.item_count } }
            }));
          })
          .catch(err => console.error('Error fetching cart:', err));
      });
    }
  });

  /* ---- 4. Scroll Detection (Sticky Header & Search Interaction) ---- */
  function handleScroll() {
    const isMobile = window.innerWidth < 750;
    if (isMobile && window.scrollY > 50) {
      header.classList.add('hlf-header--scrolled');
    } else {
      header.classList.remove('hlf-header--scrolled');
    }
  }
  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll(); // Run once initially
})();
